import { render, staticRenderFns } from "./complianceList.vue?vue&type=template&id=f6b3d502&"
import script from "./complianceList.vue?vue&type=script&lang=js&"
export * from "./complianceList.vue?vue&type=script&lang=js&"
import style0 from "./complianceList.vue?vue&type=style&index=0&id=f6b3d502&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports